/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { EncounterStayType } from './EncounterStayType';
import {
    EncounterStayTypeFromJSON,
    EncounterStayTypeFromJSONTyped,
    EncounterStayTypeToJSON,
    EncounterStayTypeToJSONTyped,
} from './EncounterStayType';

/**
 * A planned encounter can correct its planned fields and stay_type. An
 * in-progress one can correct actual_start_at, planned_end_at,
 * is_planned_end_confirmed and stay_type. A completed one can correct
 * actual_start_at, actual_end_at and stay_type.
 * 
 * @export
 * @interface CorrectEncounterRequest
 */
export interface CorrectEncounterRequest {
    /**
     * 
     */
    planned_start_at?: Date;
    /**
     * 
     */
    is_planned_start_confirmed?: boolean;
    /**
     * 
     */
    actual_start_at?: Date;
    /**
     * 
     */
    actual_end_at?: Date;
    /**
     * 
     */
    planned_end_at?: Date;
    /**
     * 
     */
    is_planned_end_confirmed?: boolean;
    /**
     * 
     */
    stay_type?: EncounterStayType;
    /**
     * 
     */
    comment?: string;
    /**
     * 409 if the episode changed since
     */
    expected_latest_history_id?: string;
}



/**
 * Check if a given object implements the CorrectEncounterRequest interface.
 */
export function instanceOfCorrectEncounterRequest(value: object): value is CorrectEncounterRequest {
    return true;
}

export function CorrectEncounterRequestFromJSON(json: any): CorrectEncounterRequest {
    return CorrectEncounterRequestFromJSONTyped(json, false);
}

export function CorrectEncounterRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CorrectEncounterRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'planned_start_at': json['planned_start_at'] == null ? undefined : (parseDateTime(json['planned_start_at'])),
        'is_planned_start_confirmed': json['is_planned_start_confirmed'] == null ? undefined : json['is_planned_start_confirmed'],
        'actual_start_at': json['actual_start_at'] == null ? undefined : (parseDateTime(json['actual_start_at'])),
        'actual_end_at': json['actual_end_at'] == null ? undefined : (parseDateTime(json['actual_end_at'])),
        'planned_end_at': json['planned_end_at'] == null ? undefined : (parseDateTime(json['planned_end_at'])),
        'is_planned_end_confirmed': json['is_planned_end_confirmed'] == null ? undefined : json['is_planned_end_confirmed'],
        'stay_type': json['stay_type'] == null ? undefined : EncounterStayTypeFromJSON(json['stay_type']),
        'comment': json['comment'] == null ? undefined : json['comment'],
        'expected_latest_history_id': json['expected_latest_history_id'] == null ? undefined : json['expected_latest_history_id'],
    };
}

export function CorrectEncounterRequestToJSON(json: any): CorrectEncounterRequest {
    return CorrectEncounterRequestToJSONTyped(json, false);
}

export function CorrectEncounterRequestToJSONTyped(value?: CorrectEncounterRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'planned_start_at': value['planned_start_at'] == null ? value['planned_start_at'] : serializeDateTime(value['planned_start_at']),
        'is_planned_start_confirmed': value['is_planned_start_confirmed'],
        'actual_start_at': value['actual_start_at'] == null ? value['actual_start_at'] : serializeDateTime(value['actual_start_at']),
        'actual_end_at': value['actual_end_at'] == null ? value['actual_end_at'] : serializeDateTime(value['actual_end_at']),
        'planned_end_at': value['planned_end_at'] == null ? value['planned_end_at'] : serializeDateTime(value['planned_end_at']),
        'is_planned_end_confirmed': value['is_planned_end_confirmed'],
        'stay_type': EncounterStayTypeToJSON(value['stay_type']),
        'comment': value['comment'],
        'expected_latest_history_id': value['expected_latest_history_id'],
    };
}

